import { useContext, useEffect, useState } from 'react';

import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';

import './index.css';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { getExplanatoryTexts } from '../../../../../../../utils';

interface PlansSectionProps {
  duplicateId?: number;
  id: number;
}

export const PlansSection = ({ duplicateId, id }: PlansSectionProps) => {
  const validateForm = new ValidateForm();

  const { stepThreeForm, plansByActivityList, getListPlansActivity } =
    useContext(StepThreeFormContext);

  
    const { globalPublicConfigs } = useContext(MasterContext);
    const { quotationInfo } = useContext(QuotationInfoContext);
    const [explanatoryText, setExplanatoryText] = useState<string>("");    
    const handleExplanatoryText = () => {
      const text = getExplanatoryTexts(
          Number(quotationInfo?.branch),
          Number(quotationInfo?.article), 
          Number(stepThreeForm?.getFieldValue(`plan-tab-${id}`)),
        globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
      );
      setExplanatoryText(text);
    };

  useEffect(() => {
    handleExplanatoryText();
    if (duplicateId) {
      const duplicatePlan = stepThreeForm?.getFieldValue(
        `plan-tab-${duplicateId}`
      );

      stepThreeForm?.setFieldValue(`plan-tab-${id}`, duplicatePlan);
    }
  }, [duplicateId, stepThreeForm, id]);

  return (
    <ContentSection level='h3' title='Planes'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Planes:',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'planes',
                rules: ['required'],
              }),
            }}
            selectProps={{ 
              options: plansByActivityList,
              onChange: handleExplanatoryText,
            }}
          />
        </ColSize>
      </RowSize>
      {!!explanatoryText && 
        <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
          {explanatoryText}
        </Typography.Text>
        }  
    </ContentSection>
  );
};
